import { Grades } from '../constants'

export const formatGrades = (grades) => {
  let output = []

  grades = grades.map((grade) => Grades.find(({ value }) => value === grade))

  for (let i = 0; i < grades.length; i++) {
    const prevIndex = Grades.indexOf(grades[i - 1])
    const currIndex = Grades.indexOf(grades[i])

    if (
      currIndex > 1 &&
      currIndex < Grades.length - 1 &&
      prevIndex === currIndex - 1
    ) {
      const last = output.pop()
      output.push(last.split('-')[0] + '-' + grades[i].text.split('-')[1])
    } else {
      output.push(grades[i].text)
    }
  }

  return output
}
